import React, { PropsWithChildren, createContext } from 'react';
import { ThemeContainer } from './theme-container';
import { EnableGenesisCoreInspector } from '../constants';
import { TextDirectionalityProvider } from './text-directionality-provider';
import { GDSThemeLoaderOptions } from './theme-types';

interface GDSThemeProviderProps {
  theme: any;
  themeOptions?: GDSThemeLoaderOptions;
  children: React.ReactNode;
}

export const ThemeContext = createContext<any>(undefined);
export const ThemeOptionsContext = createContext<
  GDSThemeLoaderOptions | undefined
>(undefined);

const getGenesisCoreInspectorStatus = () =>
  window.localStorage.getItem(EnableGenesisCoreInspector) === 'true';

export const GDSThemeProvider: React.FunctionComponent<
  PropsWithChildren<GDSThemeProviderProps>
> = ({ theme, children, themeOptions }) => {
  if (theme === undefined) {
    throw new Error('GDSThemeProvider requires a theme object.');
  }

  const isGenesisCoreInspectorEnabled = getGenesisCoreInspectorStatus();

  if (isGenesisCoreInspectorEnabled) {
    console.warn(
      'Genesis Core Inspector is enabled. You may experience a layout shift in some block level elements that may appear inline due to the added Genesis Core Inspector styles.',
    );
  }

  return (
    <TextDirectionalityProvider>
      <ThemeContext.Provider value={theme}>
        <ThemeOptionsContext.Provider value={themeOptions}>
          <ThemeContainer theme={theme}>{children}</ThemeContainer>
        </ThemeOptionsContext.Provider>
      </ThemeContext.Provider>
    </TextDirectionalityProvider>
  );
};
